<template>
  <div>
    <div class="Blocks">
      <div class="Block_Top">
        <ul>
          <li :class="num == 1 ? 'active' : ''" @click="dianji(1)">
            Transfers
          </li>
          <li :class="num == 2 ? 'active' : ''" @click="dianji(2)">Holders</li>
          <li :class="num == 3 ? 'active' : ''" @click="dianji(3)">
            Inventory
          </li>
          <li :class="num == 4 ? 'active' : ''" @click="dianji(4)">Contract</li>
        </ul>
        <!-- <div class="search">
          <input type="text" placeholder="Filter Address / Hash" />
          <img src="@/assets/pc/Index/seach.png" />
        </div> -->
      </div>
      <div v-show="num == 1">
        <div v-show="list.length > 0">
          <div class="Block_list">
            <ul class="block_list_Top">
              <li>Hash</li>
              <li>Type</li>
              <li>Age</li>
              <li>From</li>
              <li>To</li>
              <li>Amout</li>
            </ul>
          </div>
          <div class="Block_List_center notranslate">
            <ul>
              <li v-for="(item, index) in list" :key="index">
                <p @click="Tash(index)">
                  {{ item.txHash1 }}
                  <!-- <img src="../../../assets/pc/Index/active.png" />
                <span @click="Hash(item.blockHash)">{{ item.blockHash }}</span> -->
                </p>
                <p>
                  <span>{{ item.functions }}</span>
                </p>
                <p>
                  {{ item.tradeTime }}
                  <!-- <span class="Hover1">
                  <span class="Hover"
                    >{{ TimeDate[index] }}<i class="iconfont">&#xe600;</i></span
                  >
                </span> -->
                </p>

                <p @click="AdderssTo(item.fromEvmAddress)">
                  {{ item.fromEvmAddress1 }}
                </p>
                <p @click="AdderssTo(item.toEvmAddress)">
                  {{ item.toEvmAddress1 }}
                </p>
                <!-- <p>{{ item.tokenAmount }}<img :src="item.image" /></p> -->
                <p
                  style="color: #fff; cursor: pointer"
                  @click="Nftsdetails(index)"
                >
                  <span v-if="item.standard == 'ERC-20'">{{
                    item.tokenAmount
                  }}</span>
                  <span style="display: inline-block; height: 34px">
                    <img
                      :src="item.logo"
                      style="
                        margin-right: 4px;
                        /* height: 34px; */
                        width: 100%;
                        height: 100%;
                        border-radius: 4px;
                        border: 1px solid #000;
                        object-fit: contain;
                      "
                    />
                  </span>
                  <!-- <img
                    :src="item.logo"
                    style="
                      margin-right: 4px;
                      /* width: 34px; */
                      height: 34px;
                      border-radius: 4px;
                    "
                  /> -->

                  <span>{{ item.contractName }}</span>
                  <span
                    v-if="item.standard == 'ERC-721'"
                    style="margin-top: 10px"
                    >{{ item.tokenAmount }}</span
                  >
                </p>
              </li>
            </ul>
          </div>
          <div :class="list.length > 10 ? 'Block_List_Bottom' : ''">
            <el-pagination
              ref="Pagination"
              :current-page.sync="PaginationIndex"
              background
              :page-size="20"
              layout="prev, pager,
      next"
              @current-change="CurrentChange"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-show="list.length <= 0">
          <EmptyState />
        </div>
      </div>
      <div v-show="num == 2">
        <HoldersList
          :holdersList="holdersList"
          :holderCount="holderCount"
          :PaginationIndex="PaginationIndex"
          @getDatepage="getDatepage"
        ></HoldersList>
      </div>
      <div v-show="num == 3">
        <InventoryList
          :inventoryList="inventoryList"
          :totalNFT="totalNFT"
          :PaginationIndex="PaginationIndex"
          :contractAddress="contractAddress"
          @getDatepage="getDatepage"
        ></InventoryList>
      </div>
      <div v-show="num == 4">
        <button
          :class="activeTab == 'tab1' ? 'changetabs1' : 'changetabs'"
          @click="changeTab('tab1')"
          v-if="isChecked == 1"
        >
          Code
        </button>
        <button
          v-if="isChecked == 1"
          :class="activeTab == 'tab2' ? 'changetabs1' : 'changetabs'"
          @click="changeTab('tab2')"
        >
          Call Contract
        </button>

        <div
          style="display: flex; justify-content: flex-end"
          v-show="activeTab == 'tab2'"
        >
          <div class="calladdress" @click="Confirm" v-if="codeaddress == null">
            <img src="../../../assets/pc/Contract/atanb.png" /><span
              >Connect wallet</span
            >
          </div>
          <div class="calladdress" v-else>
            <img src="../../../assets/pc/Contract/atanb.png" /><span>{{
              codeaddress
            }}</span>
          </div>
          <!-- <div class="calladdress" @click="callress" v-if="codeaddress == null">
            <img src="../../../assets/pc/Contract/atan.png" /><span
              >Call address</span
            >
          </div>
          <div class="calladdressa" @click="updateresss" v-else>
            <div style="display: flex">
              <img src="../../../assets/pc/Contract/atan.png" />
              <span style="color: rgba(255, 255, 255, 0.7) !important"
                >Call addrees:</span
              >
            </div>
            <div style="display: flex; margin-left: 10px">
              <span>{{ codeaddress }}</span>
              <img src="../../../assets/pc/Contract/atana.png" />
            </div>
          </div> -->
        </div>
        <div class="calladdressbox" v-show="flogs">
          <div class="calladdressbox_w">
            <div class="callbox">
              <el-form ref="form" :model="form" :rules="rules">
                <div class="putext">
                  <div class="puttit">Address</div>
                  <el-form-item prop="address">
                    <el-input
                      v-model="form.address"
                      class="inpttext"
                      placeholder="base58"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="putext">
                  <div class="puttit">Public key</div>
                  <el-form-item prop="publickey">
                    <el-input
                      v-model="form.publickey"
                      class="inpttext"
                      placeholder="string"
                    ></el-input>
                    <!-- <el-input v-model="form.email" class="inpttext"></el-input> -->
                  </el-form-item>
                </div>
                <div class="putextbtn">
                  <div class="cancel" @click="quxiao">Cancel</div>
                  <div class="submit" @click="Confirm">Confirm</div>
                </div>
              </el-form>
            </div>
          </div>
        </div>

        <div class="boxlist" v-show="activeTab == 'tab1'">
          <!-- <AnalysisList></AnalysisList> -->
          <div class="Contract5">
            <div v-if="isChecked == 0">
              <div class="ContractName">
                <div class="Contracttit">
                  <img :src="imgnamea" />
                  <div>
                    Contract source code is unverified.l am the creator of the
                    contract,<span @click="goto"
                      >Verify and launch source code</span
                    >
                  </div>
                </div>
              </div>
              <!-- <div class="ContractName">
            <div class="Contracttits">Contract Name :</div>
            <div class="Contractconts">{{ contractNames }}</div>
          </div>
          <div class="ContractName">
            <div class="Contracttits">Compiler Version :</div>
            <div class="Contractconts" v-if="compileVersion=='' || compileVersion==null" >null</div>
            <div class="Contractconts" v-else >{{ compileVersion }}</div>
          </div> -->
            </div>
            <div v-if="isChecked == 1">
              <div class="ContractName">
                <div class="Contracttit">
                  <img :src="imgname" />
                  <div>Contract Source Code Verified (Exact Match)</div>
                </div>
              </div>
              <div class="ContractName">
                <div class="ContractNamebox">
                  <div class="Contracttits">Contract Name :</div>
                  <div class="Contractconts">{{ contractNames }}</div>
                </div>
              </div>
              <div class="ContractName">
                <div class="ContractNamebox">
                  <div class="Contracttits">Compiler Version :</div>
                  <div class="Contractconts">{{ allVersion }}</div>
                </div>
                <div class="ContractNamebox">
                  <div class="Contracttits" style="width: 97px !important">
                    License :
                  </div>
                  <div class="Contractconts">{{ license }}</div>
                </div>
              </div>
            </div>
            <div class="Contract5_tit" v-if="isChecked == 1">
              <div class="Contract5_titl">Contract Code</div>
              <div class="Contract5_titr">
                <img
                  v-clipboard:copy="sourceCode"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  src="@/assets/pc/charts/copy.png"
                />
                <!-- <img src="@/assets/pc/charts/link.png" />
              <img src="@/assets/pc/charts/fang.png" /> -->
              </div>
            </div>
          </div>
          <div class="codeEditBox" v-if="sourceCode !== null && isChecked == 1">
            <editor
              v-model="sourceCode"
              @init="editorInit"
              @input="codeChange"
              lang="javascript"
              :options="editorOptions"
              theme="vibrant_ink"
            ></editor>
            <!-- <div v-else>
            <EmptyState />
          </div> -->
          </div>
          <div class="Contract5">
            <div class="Contract5_tit">
              <div class="Contract5_titl">Bytecode</div>
              <div class="Contract5_titr">
                <img
                  v-clipboard:copy="byteCode"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  src="@/assets/pc/charts/copy.png"
                />
                <!-- <img src="@/assets/pc/charts/link.png" />
              <img src="@/assets/pc/charts/fang.png" /> -->
              </div>
            </div>
          </div>
          <div class="codeEditBox">
            <editor
              v-model="byteCode"
              @init="editorInit"
              @input="codeChange"
              lang="java"
              :options="editorOptions"
              theme="vibrant_ink"
            ></editor>
            <!-- <div v-else>
            <EmptyState />
          </div> -->
          </div>
        </div>
        <div class="boxlist" v-show="activeTab == 'tab2'" v-if="isChecked == 1">
          <el-collapse v-model="activeName" accordion @change="handleChangeaa">
            <el-collapse-item
              :name="item.id.toString()"
              v-for="(item, index) in abiJsonall"
              :key="index"
            >
              <template slot="title">
                <div class="boxli">
                  <div>{{ item.name }}</div>
                  <img
                    src="../../../assets/pc/Contract/link.png"
                    v-clipboard:copy="currentURL + '#&' + item.id"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    @click="stopCollapse"
                  />
                </div>
                <!-- <el-button @click="copyLink()" class="tag">复制链接</el-button> -->
              </template>
              <div class="listbox">
                <!-- <el-form :model="dynamicValidateForm" ref="dynamicValidateForm"> -->
                <div class="listboxli">
                  <div v-for="(item1, index) in item.inputs" :key="index">
                    <div class="listboxlitit">
                      {{ item1.name }} <span>(</span>{{ item1.type
                      }}<span>)</span>
                    </div>
                    <!-- <el-form-item :prop="item1.values"> -->
                    <div class="listboxlicon">
                      <input
                        v-model="item1.value"
                        :type="item1.type"
                        :placeholder="item1.type"
                      />
                    </div>
                    <!-- </el-form-item> -->
                  </div>

                  <!-- 新添加的类型为"stateMutability": "payable"的开始 -->
                  <div v-if="item.stateMutability == 'payable'">
                    <div class="listboxlitit">payableValue</div>
                    <!-- <el-form-item :prop="item1.values"> -->
                    <div class="listboxlicon">
                      <input
                        v-model="forma.payableValue"
                        type="number"
                        placeholder="Number"
                      />
                    </div>

                    <!-- </el-form-item> -->
                  </div>
                  <!-- 新添加的类型为"stateMutability": "payable"的开始 -->
                  <div
                    class="call1"
                    @click="Calls()"
                    v-if="item.inputs.length > 0"
                  >
                    Call
                  </div>

                  <div class="outiput">
                    <div style="display: flex; flex-direction: column">
                      <div style="display: flex">
                        <img
                          src="../../../assets/pc/Contract/left.png"
                          v-if="item.results !== ''"
                        />

                        <div
                          class="outtext"
                          v-for="(item2, index) in item.outputs"
                          :key="index"
                        >
                          <span v-if="item.results !== ''"
                            >{{ item2.name }} {{ item2.type }}</span
                          >
                        </div>
                      </div>
                      <div class="sucess">
                        <div
                          v-for="(item3, index) in item.results"
                          :key="index"
                        >
                          {{ item3 }}
                        </div>
                      </div>
                    </div>
                    <div class="errors">{{ item.resultser }}</div>
                  </div>
                </div>
                <!-- </el-form> -->
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Editor from "vue2-ace-editor";
//黑底色
import "brace/theme/tomorrow_night_eighties";
//蓝底色
import "brace/theme/tomorrow_night_blue";
//黑底色
import "brace/theme/vibrant_ink";
import { NftDetailColumns, NftDetail } from "@/assets/server/api";
import EmptyState from "../EmptyState/EmptyState.vue";

import InventoryList from "./InventoryList.vue";
import HoldersList from "./HoldersList.vue";
// import AnalysisList from "./AnalysisList.vue";

import { timestampConvertTime } from "@/utils/utils";
import { goPAGE, formatSeconds, listType, getSubStr } from "@/utils/utils";
export default {
  props: [
    "contractAddress",
    "sourceCode",
    "totalSupply",
    "byteCode",
    "isChecked",
    "license",
    "compileVersion",
    "contractNames",
    "allVersion",
    "abiJsonall",
    "deployutxo",
    "creator",
  ],
  data() {
    return {
      codeaddress: "",
      flogs: false,
      form: {
        address: "",
        publickey: "",
      },
      rules: {
        address: [
          {
            required: true,
            message: "address  is required",
            trigger: "change",
          },
          {
            min: 33,
            max: 48,
            message: "Please enter a address between 35 and 48 characters.",
            trigger: "blur",
          },
        ],
        publickey: [
          {
            required: true,
            message: "publickey  is required",
            trigger: "change",
          },
          {
            min: 45,
            message: "Please enter a publickey 45 characters.",
            trigger: "blur",
          },
        ],
      },
      abiJsonaa: [],
      abiJsonaaall: [],
      abiJson: [],
      hashValue: "",
      currentURL: "",
      resultsucess: [],
      resulterror: "",
      valuenum: "",
      valuenum1: "",
      forma: {
        deployer: "",
        deployutxo: "",
        name: "",
        type: "",
        inputs: [],
        outputs: [],
        stateMutability: "",
        pubstr: "",
        addr: "",
        payableValue: "",
      },
      btnshow: false,
      activeName: "",

      activeTab: "tab1", //开始
      originalWidth: 30, // 替换为你图片的原始宽度
      list: [],
      PaginationIndex: 1,
      num: 1,
      total: null,
      contractName: "",
      // creator: "",
      holders: "",
      logo: "",
      txCount: "",
      column: "transfers",
      //holders列表中的内容
      holdersList: [],
      holderCount: "",
      //holders列表中的内容结束
      //Inventory列表开始
      inventoryList: [],
      imgname: require("@/assets/pc/TopValidators/TopValidators4.png"),
      imgnamea: require("@/assets/pc/TopValidators/tan.png"),
      imgurlnft: require("@/assets/pc/Index/nft.png"),
      ImgUrl: require("@/assets/pc/Index/amount.png"), //向下下拉箭头
      totalNFT: "",
      // isChecked:"",
      // license:"",
      // compileVersion:"",
      //Inventory列表结束
      editorOptions: {
        // 设置代码编辑器的样式
        wrap: true,
        // 设置代码编辑器的样式
        enableBasicAutocompletion: true, //启用基本自动完成
        enableSnippets: true, // 启用代码段
        //  enableLiveAutocompletion: true, //启用实时自动完成
        tabSize: 0, //标签大小
        fontSize: 14, //设置字号
        readOnly: true,
        showPrintMargin: false, //去除编辑器里的竖线
        wrapBehavioursEnabled: true, //启用换行
        autoScrollEditorIntoView: false, //启用滚动
        showFoldWidgets: true, // 显示折叠部件
        fadeFoldWidgets: true, // 淡入折叠部件
      },
    };
  },
  watch: {
    deep: true,

    contractAddress(val) {
      this.contractAddress = val;
      //console.log(this.contractAddress);
    },
  },
  components: {
    // Pagination,
    EmptyState,
    // Pagination2,
    HoldersList,
    InventoryList,
    Editor,
    // AnalysisList
  },
  mounted() {
    //   this.codeaddress = localStorage.getItem("form");
    // //  console.log(this.codeaddress);
    //   if (localStorage.getItem("form") !== null) {
    //     this.codeaddress = localStorage.getItem("form");
    //     this.codeaddress = getSubStr(this.codeaddress, 0, 3);
    //   }
    if (window.treeWallet) {
      this.accountsChanged();
      if (window.treeWallet.isConnected == true) {
        //   console.log("no");
        this.codeaddress = localStorage.getItem("form");
        // console.log(this.codeaddress);
        if (localStorage.getItem("form") !== null) {
          this.codeaddress = localStorage.getItem("form");
          this.codeaddress = getSubStr(this.codeaddress, 0, 3);
        }
      }
      if (window.treeWallet.isConnected == false) {
        //  console.log("nonno");
        this.codeaddress = null;
      }
    }
    //  this.PaginationIndex =  1;
    this.GetnftDetail();
    this.currentURL = window.location.href;
    //  console.log(this.currentURL);
    if (this.currentURL.indexOf("#&") !== -1) {
      this.currentURL = this.currentURL.split("#&")[0];
    }
    // console.log("当前连接地址:", this.currentURL);
    this.hashValue = this.$route.hash.substring(2);
    this.activeName = this.hashValue.toString();
    // console.log(this.hashValue);
    // console.log(this.activeName);
    // console.log(this.hashValue.length);
    if (this.hashValue.length > 0) {
      this.num = 4;
      this.activeTab = "tab2";
      this.activeName = this.hashValue.toString();
      this.getTxList();
      this.valuenum1 = this.activeName;
    }
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  methods: {
    async accountsChanged() {
      if (window.treeWallet) {
        try {
          await window.treeWallet.on("accountsChanged", (accounts) => {
            this.codeaddress = accounts;
            // console.log(accounts);
            // console.log(this.codeaddress[0])
            //   this.codeaddress = getSubStr(this.codeaddress[0], 0, 3);

            if (this.codeaddress.length == 0) {
              this.codeaddress = null;
            } else {
              localStorage.setItem("form", this.codeaddress);
              this.codeaddress = localStorage.getItem("form");
              this.codeaddress = getSubStr(this.codeaddress, 0, 3);
              // console.log(this.codeaddress)
            }
          });
        } catch (err) {
          this.$message(err);
        }
      }
    },
    quxiao() {
      this.flogs = false;
      this.form.address = "";
      this.form.publickey = "";
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    async Confirm() {
      try {
        this.address = await window.treeWallet.connect();
        localStorage.setItem("form", this.address);
        this.publickey = await window.treeWallet.getPublicKey();
        localStorage.setItem("forma", this.publickey);
        this.codeaddress = localStorage.getItem("form");
        this.codeaddress = getSubStr(this.codeaddress, 0, 3);
        //     this.$message("Success");
        this.$message("Success");
        //console.log(res);
      } catch (error) {
        console.log(error);
      }
      //   this.$refs.form.validate(async (success) => {
      //     //    if (this.validatePassword()) {
      //  //   console.log(this.form);
      //     if (success) {
      //       localStorage.setItem("form", this.form.address);
      //       localStorage.setItem("forma", this.form.publickey);
      //       this.codeaddress = localStorage.getItem("form");
      //       this.codeaddress = getSubStr(this.codeaddress, 0, 3);
      //       this.$message("Success");
      //       this.flogs = false;
      //     } else {
      //       //  this.$refs.form.clearValidate();
      //       this.$message(" This field are not filled in ");
      //       // this.$refs.form.clearValidate();
      //       return false;
      //     }
      //   });
    },
    // callress() {
    //   this.flogs = true;
    // },
    updateresss() {
      this.flogs = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.form.address = localStorage.getItem("form");
      this.form.publickey = localStorage.getItem("forma");
    },
    isFormValid(val) {
      // console.log(val);
      // console.log(val.id)
      // // console.log(this.valuenum)
      // // console.log(this.forma)
      // // if(val.id.toString()==this.valuenum.toString()){
      // //   console('相等了')
      // // }
      // //  console.log(val.inputs[0].value)
      //  return val.inputs[0].value.trim() !== ""
    },
    async getTxList() {
      let formData = new FormData();
      let params = {
        contractAddress: this.contractAddress,
        userId: "",
      };
      //  console.log(params);
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await NftDetail(formData);
      // console.log(res);
      this.abiJsonaa = res.result.abiJson;
      //  console.log(this.abiJsonaa);
      if (this.abiJsonaa !== null) {
        if (this.abiJsonaa.length > 0) {
          // console.log(this.abiJson.length);
          for (var i = 0; i < this.abiJsonaa.length; i++) {
            if (this.abiJsonaa[i].type == "function") {
              this.abiJsonaaall.push(this.abiJsonaa[i]);

              //  console.log(this.abiJson[i].inputs);
              //  console.log(this.abiJson[i].outputs);
            }
          }
          //    console.log(this.abiJsonaaall);
          for (var j = 0; j < this.abiJsonaaall.length; j++) {
            this.abiJsonaaall[j].id = j + 1;
            //this.abiJsonaaall[j].results = "";
            if (
              this.abiJsonaaall[j].id == this.activeName &&
              this.abiJsonaaall[j].inputs.length == 0
            ) {
              this.forma.name = this.abiJsonaaall[j].name;
              this.forma.type = this.abiJsonaaall[j].type;
              this.forma.inputs = this.abiJsonaaall[j].inputs;
              this.forma.outputs = this.abiJsonaaall[j].outputs;
              this.forma.stateMutability = this.abiJsonaaall[j].stateMutability;
              this.forma.deployer = res.result.creator;
              this.forma.deployutxo = res.result.deployutxo;
              this.Callsaxios();
            }
          }
        }
      }
    },
    handleChangeaa(val) {
      // console.log(val);
      this.valuenum = val;
      this.valuenum1 = val;
      for (var i = 0; i < this.abiJsonall.length; i++) {
        if (
          this.abiJsonall[i].id == this.valuenum &&
          this.abiJsonall[i].inputs.length == 0
        ) {
          //  console.log("打开连接走这了");
          //  this.forma.contractAddress= this.contractAddress;
          this.forma.name = this.abiJsonall[i].name;
          this.forma.type = this.abiJsonall[i].type;
          this.forma.inputs = this.abiJsonall[i].inputs;
          this.forma.outputs = this.abiJsonall[i].outputs;
          this.forma.stateMutability = this.abiJsonall[i].stateMutability;
          this.forma.deployer = this.creator;
          this.forma.deployutxo = this.deployutxo;
          this.forma.pubstr = localStorage.getItem("forma");
          // console.log(this.forma.pubstr);
          this.forma.addr = localStorage.getItem("form");
          // console.log(this.forma.addr);
          if (this.abiJsonall[i].stateMutability !== "payable") {
            this.forma.payableValue = "";
          }
          this.Callsaxios();
        }
      }
    },
    Calls() {
      // console.log(this.valuenum);
      // console.log(this.forma);
      // console.log(this.abiJsonall.length);
      // console.log(this.abiJsonall[0]);

      for (var i = 0; i < this.abiJsonall.length; i++) {
        if (this.abiJsonall[i].id == this.valuenum) {
          for (var j = 0; j < this.abiJsonall[i].inputs.length; j++) {
            if (this.abiJsonall[i].inputs[j].value == "") {
              this.$message("This field are not filled in ");
              return false;
            }
          }
          if (
            this.abiJsonall[i].stateMutability == "payable" &&
            !this.isValidNumber(this.forma.payableValue)
          ) {
            this.$message(
              "Invalid input for payable value. Please enter a positive number or decimal."
            );
            return false;
          }

          //  console.log(this.abiJsonall[i].inputs);
          this.forma.deployer = this.creator;
          this.forma.deployutxo = this.deployutxo;
          //  console.log(this.forma.deployer);
          //  console.log(this.forma.deployutxo);
          //   deployer: "",
          // deployutxo:"",
          //   this.forma.contractAddress = this.contractAddress;
          this.forma.name = this.abiJsonall[i].name;
          this.forma.type = this.abiJsonall[i].type;
          this.forma.inputs = this.abiJsonall[i].inputs;
          this.forma.outputs = this.abiJsonall[i].outputs;
          this.forma.stateMutability = this.abiJsonall[i].stateMutability;
          this.forma.pubstr = localStorage.getItem("forma");
          this.forma.addr = localStorage.getItem("form");
          //  console.log(this.forma.payableValue);
          if (this.abiJsonall[i].stateMutability !== "payable") {
            this.forma.payableValue = "";
          }
        }
      }
      // console.log(this.forma);
      this.Callsaxios();
    },
    isValidNumber(value) {
      const regex = /^[+]?\d*\.?\d+$/;
      return regex.test(value);
    },
    Callsaxios() {
      axios
        .post(
          //"http://192.168.1.241:9200/tfscBrowser/contract/saveTempContractInfo",
          // "http://192.168.1.123:9200/tfscBrowser/contract/callContract",
          "https://explorer.tfsc.io/tfscBrowser/contract/callContract",
          this.forma,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          // 请求成功状态为200说明添加成功
          // console.log(res);
          // console.log(res.data.code);
          // console.log(res.data.result);

          if (res.data.code == 200) {
            if (
              res.data.result == null ||
              res.data.result == "" ||
              res.data.result == []
            ) {
              // console.log("我走这里了asdsdf");
              var indexs = this.valuenum1 - 1;
              // console.log(indexs);
              this.$set(this.abiJsonall, indexs, {
                ...this.abiJsonall[indexs],
                results: ["Success"],
                resultser: "",
              });
            } else {
              //  console.log("我走这里了");
              var indexs = this.valuenum1 - 1;
              //   console.log(indexs);
              this.$set(this.abiJsonall, indexs, {
                ...this.abiJsonall[indexs],

                results: res.data.result,
                resultser: "",
              });
            }
            //  this.forma.payableValue="";
            // this.abiJsonall[indexs].results = res.data.result;
            //   console.log(this.abiJsonall);
          } else if (res.data.code == 400) {
            var indexs = this.valuenum1 - 1;
            //   console.log(indexs);
            this.$set(this.abiJsonall, indexs, {
              ...this.abiJsonall[indexs],
              resultser: res.data.result,
              results: "",
            });
            //   console.log(this.abiJsonall);
            //  this.forma.payableValue="";
          }
        })
        .catch((error) => {
          //  console.log(error);
          this.$message(" This field are not filled in ");
        });
    },
    stopCollapse(e) {
      //alert(111);
      // console.log(e);
      return e.stopPropagation();
    },
    changeTab(tab) {
      // console.log(tab);
      this.activeTab = tab;
    },
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    goto() {
      this.$router.push("/pc/Verify");
      // this.$message("Coming Soon");
    },
    amoutto(index) {
      let params = {
        contractAddress: this.contractAddress,
        tokenId: this.list[index].tokenAmount,
      };
      // console.log(params);
      this.$router.push({ path: "/pc/NFTslistdetail", query: params });
    },
    getDatepage(data) {
      this.PaginationIndex = data;
      // console.log(this.PaginationIndex);
      this.GetnftDetail();
    },
    onCopy(e) {
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    editorInit() {
      require("brace/theme/chrome");
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/yaml");
      require("brace/mode/json");
      require("brace/mode/less");
      require("brace/snippets/json");
      require("brace/mode/lua");
      require("brace/snippets/lua");
      require("brace/mode/javascript");
      require("brace/snippets/javascript");
    },
    codeChange(val) {
      val; //console.log(val)
    },
    dianji(index) {
      this.num = index;
      if (this.num == 1) {
        this.PaginationIndex = 1;
        this.column = "transfers";
        this.GetnftDetail();
      } else if (this.num == 2) {
        this.PaginationIndex = 1;
        this.column = "holders";
        this.GetnftDetail();
      } else if (this.num == 3) {
        this.PaginationIndex = 1;
        this.column = "inventory";
        this.GetnftDetail();
      }
    },
    CurrentChange(val) {
      this.PaginationIndex = val;

      // this.blockList();
      this.GetnftDetail();
    },

    async GetnftDetail() {
      let formData = new FormData();
      let params = {
        contractAddress: this.contractAddress,
        pageNum: this.PaginationIndex,
        pageSize: 20,
        column: this.column,
      };
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await NftDetailColumns(formData);
      // console.log(res);
      this.holderCount = res.result.holderCount;
      //     console.log(this.holderCount);
      this.contractName = res.result.contractName;
      // this.creator = res.result.creator;
      this.holders = res.result.holders;
      // this.logo = res.result.logo;
      this.total = res.result.count;
      //   console.log(this.total);
      // this.sourceCode = res.result.sourceCode;
      // console.log(this.sourceCode);
      this.txCount = res.result.txCount;
      if (this.num == 1) {
        this.list = res.result.nftTxList;
        //   console.log(this.list);
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (var i = 0; i < this.list.length; i++) {
          if (this.list[i].nftNameList !== "") {
            this.list[i].nftNameList = JSON.parse(this.list[i].nftNameList);
            this.list[i].contractName = this.list[i].nftNameList[0];
          }
          if (this.list[i].nftImageList !== "") {
            var images = JSON.parse(this.list[i].nftImageList);
            // console.log(images);
            this.list[i].logo = images[0];
            // if (this.check_is_img(this.list[i].logo) == false) {
            //   this.list[i].logo = this.ImgUrl;
            // }
          } else {
            this.list[i].logo = this.imgurlnft;
          }
          if (this.list[i].logo == "") {
            //    console.log(111);
            this.list[i].logo = this.imgurlnft;
          }
          this.list[i].tokenAmount = this.list[i].tokenAmount.split(",")[0];
          this.list[i].txHash1 = getSubStr(this.list[i].txHash, 0, 6);
          this.list[i].fromEvmAddress1 = getSubStr(
            this.list[i].fromEvmAddress,
            0,
            6
          );
          this.list[i].toEvmAddress1 = getSubStr(
            this.list[i].toEvmAddress,
            0,
            6
          );
          let timestamp = Math.floor(
            this.gltime(this.list[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].tradeTime = formatSeconds(s);
        }
      } else if (this.num == 2) {
        this.holdersList = res.result.holderList;
        this.holderCount = res.result.holderCount;
        //     console.log(this.holdersList);
        //      console.log(this.holderCount);
        if (this.holdersList.length > 0) {
          for (var i = 0; i < this.holdersList.length; i++) {
            this.holdersList[i].sum = (
              (parseFloat(this.holdersList[i].quantity) /
                parseFloat(this.totalSupply)) *
              100
            ).toFixed(6);
            //    console.log( this.holdersList);
          }
        }
      } else if (this.num == 3) {
        this.inventoryList = res.result.inventoryList;
        // console.log(this.inventoryList);
        this.totalNFT = res.result.totalNFT;
        //  console.log(this.totalNFT);
        for (var i = 0; i < this.inventoryList.length; i++) {
          if (
            this.inventoryList[i].image == "" ||
            this.check_is_img(this.inventoryList[i].image) == false
          ) {
            this.inventoryList[i].image = this.imgurlnft;
          }
          this.inventoryList[i].ownerAddress1 = getSubStr(
            this.inventoryList[i].ownerAddress,
            0,
            6
          );
          // if(this.inventoryList[i].contractName==''){
          //   this.inventoryList[i].contractName=this.inventoryList[i].tfscOwner1;
          // }
        }
        // inventoryList:[],
        // totalNFT:''
      }
      // contractName: "",
      // creator: "",
      // holders: "",
      // logo: "",
      // sourceCode: "",
      // totalSupply: "",
      // txCount: "",
    },
    async blockList() {
      this.Page1 = 1;
      const params = {
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      await BlockList(formData).then((res) => {
        this.list = res.result.tradeList;
        this.total1 = res.result.total;
        this.index = 1;
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (let i = 0; i < this.list.length; i++) {
          let UTCTime =
            res.result.tradeList[i].tradeTime -
            this.getClientTimezone * 3600000;
          this.TimeDate[i] = timestampConvertTime(UTCTime);
          let timestamp = Math.floor(
            this.gltime(this.list[i].tradeTime) / 1000
          );

          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].tradeTime = formatSeconds(s);
        }
      });
    },
    Nftsdetails(index) {
      //   console.log(index);

      let params = {
        contractAddress: this.contractAddress,
        tokenId: this.list[index].tokenAmount,
      };
      this.$router.push({ path: "/pc/NFTslistdetail", query: params });
    },
    AdderssTo(index) {
      this.$router.push({ path: "/pc/BkHash", query: { query: index } });
    },
    Tash(index) {
      //  console.log(this.list);
      // this.$router.push({ path: "/pc/To", query: { txHash: this.list[index].txHash, type: 8,standard:this.list[index].standard } });
      let params = {
        txHash: this.list[index].txHash,
        type: 8,
        standard: this.list[index].standard,
      };
      this.$router.push({ path: "/pc/To", query: params });
    },
    Block(index) {
      this.$router.push({
        path: "/pc/BkHeight",
        query: { height: index },
      });
    },
    Hash() {
      // this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });

      this.$router.push({ path: "/pc/NFTslistdetail" });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-input__inner {
  background-color: #000 !important;
  border: none !important;
}
/deep/.ace_gutter {
  bottom: none;
  left: none;
}
/* .ace_content{
  height: 500px !important;

} */
/deep/.ace_gutter-cell.ace_error {
  background-image: none !important;
}
/deep/.ace_gutter-cell.ace_warning {
  background-image: none !important;
}
/deep/::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 20px;
  height: 6px;
  /* border-radius: 24px; */
  background: #13161b;
}
/deep/::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}
/deep/::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 25px;

  background: #404040;
  transition: color 0.2s ease;
}
/deep/::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
</style>
<style lang="less" scoped>
.ace_gutter-layer {
  background: #0b0c0f !important;
}
.Contract5 {
  width: 1080px;
  margin: 0 auto;
  .ContractName {
    display: flex;
    .Contracttit {
      display: flex;

      // margin-bottom: 15px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
      div {
        height: 20px;
        font-size: 14px;
        font-family: Source Han Sans-Regular, Source Han Sans;
        font-weight: 400;
        color: #898b8d;
        line-height: 20px;
        span {
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .Contracttits {
      height: 20px;
      font-size: 14px;
      font-family: Source Han Sans-Regular, Source Han Sans;
      font-weight: 400;
      color: #898b8d;
      line-height: 20px;
      width: 174px;
      margin-top: 28px;
    }
    .Contractconts {
      margin-left: 160px;
      height: 20px;
      font-size: 14px;
      font-family: Source Han Sans-Regular, Source Han Sans;
      font-weight: 400;
      color: #898b8d;
      line-height: 20px;
      margin-top: 28px;
    }
    .ContractNamebox {
      display: flex;
      .Contracttits {
        width: 170px;
        margin-right: 0px;
      }
      .Contractconts {
        margin-left: 0px !important;
        margin-right: 120px;
      }
    }
  }
  // border: 1px solid red;
  .Contract5_tit {
    margin-top: 28px;
    display: flex;
    justify-content: space-between;
    .Contract5_titl {
      height: 26px;
      font-size: 18px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 26px;
      // margin-left: 40px;
    }
    .Contract5_titr {
      // margin-right: 40px;
      img {
        width: 28px;
        height: 28px;
        // margin-right: 14px;
      }
    }
  }
  .codeEditBox {
    width: 1080px;
    margin: 0 auto;
    margin-top: 20px;
    height: 500px !important;
    // border: 1px solid red;
  }
}
.codeEditBox {
  width: 1080px;
  height: 500px;
  margin: 0 auto;
  margin-top: 20px;
}
.Blocks {
  padding: 36px 20px;
  background: #000;
  width: 1160px;
  // height: 1480px;
  border-radius: 16px 16px 16px 16px;
  .Block_Top {
    margin-bottom: 24px;
    display: flex;
    ul {
      display: flex;
      width: 352px;
      height: 54px;
      line-height: 54px;
      background: #1c1e24;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      li {
        width: 88px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        color: rgba(255, 255, 255, 0.7);
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        cursor: pointer;
      }
      // li:nth-child(1){
      //   padding-left: 8px;
      // }
      .active {
        width: 84px;
        height: 42px;
        line-height: 42px;
        margin-top: 6px;
        background: #000000;
        color: #00ffaa;
        font-size: 14px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        margin-left: 8px;
        margin-right: 8px;
      }
    }
    .total {
      display: inline-block;
      font-size: 14px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #898b8d;
      margin-left: 30px;
      line-height: 24px !important;
    }
    .search {
      width: 380px;
      height: 40px;
      background: #18191e;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      margin-left: 356px;
      display: flex;
      justify-content: space-between;
      input {
        height: 40px;
        border: none;
        margin-left: 20px;
      }
      img {
        width: 21px;
        height: 21px;
        margin-top: 12px;
        margin-right: 20px;
      }
    }
    span:nth-child(1) {
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      -webkit-background-clip: text;
    }
  }
  .Block_list {
    //  height: 1480px;
    .block_list_Top {
      display: flex;
      width: 1120px;
      height: 60px;
      background: #14151a;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      padding: 0 20px;
      li {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        line-height: 62px;
        -webkit-background-clip: text;
      }
      li:nth-child(1) {
        flex: 0 0 18%;
      }
      li:nth-child(2) {
        flex: 0 0 18%;
      }
      li:nth-child(3) {
        flex: 0 0 18%;
      }
      li:nth-child(4) {
        flex: 0 0 13%;
      }
      li:nth-child(5) {
        flex: 0 0 13%;
      }
      li:nth-child(6) {
        flex: 0 0 18%;
        text-align: center;
        // border: 1px solid red;
      }
    }
  }
  .Block_List_center {
    ul {
      height: 620px;
      padding: 0 20px;
      li:last-child {
        //   border-bottom: none;
      }
      li {
        display: flex;
        height: 62px;
        border-bottom: 1px solid #22252e;
        line-height: 62px;
        p {
          font-size: 14px;
          font-family: SF Pro Text-Regular, SF Pro Text;
          font-weight: 400;
          -webkit-background-clip: text;
        }
      }
      li:nth-child(10) {
        //   border: none;
      }
      p:nth-child(1) {
        flex: 0 0 18%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #fff;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        img {
          width: 34px;
          height: 34px;
          background: #22252e;
          border-radius: 172px 172px 172px 172px;
          opacity: 1;
          margin-top: 10px;
          margin-right: 5px;
        }
        span {
          display: inline-block;
          width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      p:nth-child(1):hover {
        color: #00ffaa;
        cursor: pointer;
      }
      p:nth-child(2) {
        flex: 0 0 18%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        position: relative;
        cursor: default;
        .Hover1 {
          display: none;
          .Hover {
            padding: 3px 10px;
            display: inline-block;
            line-height: 20px;
            position: absolute;
            top: -10px;
            left: 0px;
            background-color: #3c485c;
            border-radius: 5px;
            i {
              position: absolute;
              top: 18px;
              left: 40%;
              transform: rotate(180deg);
              color: #3c485c;
            }
          }
        }
      }
      p:nth-child(2):hover {
        .Hover1 {
          display: block !important;
        }
      }
      p:nth-child(3) {
        flex: 0 0 18%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        span {
          display: inline-block;
          width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      p:nth-child(4) {
        flex: 0 0 13%;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
      }
      p:nth-child(4):hover {
        color: #00ffaa;
      }
      p:nth-child(5) {
        flex: 0 0 13%;
        text-align: left;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
      }
      p:nth-child(5):hover {
        color: #00ffaa;
      }
      p:nth-child(6) {
        flex: 0 0 18%;
        // border: 1px solid red;
        text-align: left;
        margin-left: 40px;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        img {
          // width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-top: 18px;
          margin-left: 6px;
        }
      }
    }
  }
  .Block_List_Bottom {
    // margin-top: 20px;
    margin-top: 636px;
  }
}
.changetabs {
  margin-bottom: 20px;
  height: 34px;
  background: #1c1e24;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  line-height: 34px;
  font-size: 15px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  margin-right: 14px;
  padding: 0px 14px;
}
.changetabs1 {
  height: 34px;
  background: #1c1e24;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  line-height: 34px;
  font-size: 15px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  color: #00ffaa;
  margin-right: 14px;
  padding: 0px 14px;
}
/deep/ button {
  border: none;
}
.calladdress,
.calladdressa {
  display: flex;

  margin-top: -30px;
  padding-bottom: 10px;
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
    margin-top: -14px;
  }
  span {
    height: 18px;
    font-family: Roboto, Roboto;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    line-height: 18px;
    margin-top: -10px;
    margin-left: 8px;
  }
}

.calladdressbox {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  // height: 1000px !important;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  overflow: auto;
  .calladdressbox_w {
    width: 473px;
    height: 216px;
    background: #13161b;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .callbox {
      width: 393px;
      margin: 0 auto;
      margin-top: 30px;
      .putext {
        display: flex;

        .puttit {
          width: 93px;
          height: 40px;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
          line-height: 40px;
        }
        .inpttext {
          width: 300px;
          height: 40px;
          // border: 1px solid red;
          /deep/.el-input__inner {
            color: #ffffff !important;
            width: 300px;
            height: 40px;
            background: #000000 !important;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            border: none;
          }
          /deep/.el-input__inner::placeholder {
            color: rgba(255, 255, 255, 0.5) !important;
          }
        }
      }
      .putextbtn {
        display: flex;
        justify-content: space-between;
        .cancel {
          font-size: 14px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #04bd80;
          margin-left: 185px;
          height: 38px;
          line-height: 38px;
          cursor: pointer;
        }
        .submit {
          width: 111px;
          height: 38px;
          line-height: 38px;
          background: rgba(0, 231, 154, 0.8);
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          font-size: 14px;
          font-family: Roboto, Roboto;
          text-align: center;
          font-weight: 500;
          color: #000000;
          cursor: pointer;
        }
      }
    }
  }
}
.boxlist {
  // border: 1px  solid green;
  // display: none;
  /* 修改折叠项标题的背景颜色 */
  .boxli {
    display: flex;
    justify-content: space-between;

    width: 1050px;
    img {
      width: 24px;
      height: 24px;
      margin-top: 14px;
      z-index: 9999999999;
    }
  }
  .listbox {
    .listboxli {
      .listboxlitit {
        height: 22px;
        font-size: 18px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #babbbd;
        line-height: 22px;
        margin-top: 18px;
        margin-bottom: 16px;
      }
      .listboxlicon {
        /deep/ input {
          width: 1080px;
          height: 58px;
          background: #13161b;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          border: 2px solid rgba(137, 139, 141, 0.3);
          padding-left: 10px;
          color: #fff;
        }
        /deep/ input::placeholder {
          color: rgba(186, 187, 189, 0.3); /* 设置placeholder颜色 */
        }
      }
      .call1 {
        width: 64px;
        height: 34px;
        background: #00e79a;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        margin-top: 16px;
        line-height: 34px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #0b0c0f;
        // margin-bottom: 20px;
      }
      // .call1 {
      //   width: 64px;
      //   height: 34px;
      //   background: #55585b;
      //   border-radius: 10px 10px 10px 10px;
      //   opacity: 1;
      //   margin-top: 16px;
      //   line-height: 34px;
      //   text-align: center;
      //   cursor: pointer;
      //   font-size: 16px;
      //   font-family: Roboto, Roboto;
      //   font-weight: 500;
      //   color: #0b0c0f;
      // }
      .outiput {
        display: flex;
        margin-top: 20px;
        img {
          width: 12px;
          height: 12px;
          margin-top: 8px;
        }
        .outtext {
          // margin-right: 20px;
          font-size: 18px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #babbbd;
          line-height: 22px;
          margin-left: 4px;
          word-break: break-all;
        }
        .sucess {
          font-size: 18px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #babbbd;
          line-height: 22px;
          margin-left: 2px;
          div {
            height: 22px;
            line-height: 22px;
            margin-top: 6px;
          }
        }
        .errors {
          font-size: 18px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #d0354c;
          line-height: 22px;
          margin-left: 2px;
        }
      }
    }
  }

  /deep/.custom-collapse-title {
    background-color: #ffcc00; /* 设置你想要的背景颜色 */
  }

  /* 修改折叠项内容的文字颜色 */
  /deep/.custom-collapse-content {
    color: red; /* 设置你想要的文字颜色 */
  }
  /deep/.el-collapse-item {
    //  background: #0B0C0F !important;
  }
  /deep/.el-collapse-item__wrap {
    background: #13161b !important;
    border: none;
    margin-bottom: 22px;
    border-radius: 10px;
    margin-top: -18px;
  }
  /deep/.el-collapse-item__header {
    background: #13161b !important;
    border: none;
    padding-left: 20px;
    padding-right: 10px;
    border-radius: 10px;
    margin-bottom: 22px;
    font-size: 16px !important;
    font-family: Roboto, Roboto !important;
    font-weight: 400 !important;
    color: #babbbd;
  }
  /deep/.el-collapse {
    border: none !important;
  }
  /deep/.el-collapse-item__content {
    padding-left: 20px;
  }
  /deep/ .el-collapse-item__arrow,
  .el-tabs__nav {
    transform: rotate(90deg);
  }
  // 点击后方向
  /deep/ .el-collapse-item__arrow.is-active {
    transform: rotate(-90deg);
  }
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
